import React from 'react';
import PropTypes from 'prop-types';

class Color extends React.Component {
    render() {
        const { color, secondaryColor, isCustomColor } = this.props;
        const classes = ['color'];

        if (secondaryColor) {
            classes.push('color--has-secondary-color');
        }

        if (isCustomColor) {
            classes.push('color--is-custom');
        }

        return (
            <div className={classes.join(' ')}>
                <div
                    className="color__inner"
                    style={{ backgroundColor: `rgb(${color.r},${color.g},${color.b})` }}
                >
                    {secondaryColor ? (
                        <div
                            className="color__secondary skewed-overlay"
                            style={{
                                backgroundColor: `rgb(${secondaryColor.r},${secondaryColor.g},${
                                    secondaryColor.b
                                })`,
                            }}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

Color.propTypes = {
    color: PropTypes.object.isRequired,
    secondaryColor: PropTypes.object,
    isCustomColor: PropTypes.bool,
};

Color.defaultProps = {
    secondaryColor: null,
    isCustomColor: false,
};

export default Color;
